<div *ngIf="!isRouterReady" class="app-loading-container">
  <loading-wheel></loading-wheel>
</div>

<div *ngIf="isRouterReady && showAppContent">
  <div class="app-header-container">
    <kwa-header platform="Clinical Decision Suite" application=""></kwa-header>
  </div>
  <div class="app-body">
    <kwa-platform-nav [items]="sidebarItems" collapsible="true"></kwa-platform-nav>
    <div
      class="app-content"
      [ngClass]="{
        'app-content-collapsed': sidebarCollapsed,
        'app-content-expanded': !sidebarCollapsed
      }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
